import React, { useState } from 'react'
import Logo from '../images/logo.svg'

let Links = [
  {name:"FEATURES", link: "/"},
  {name:"PRICING", link: "/"},
  {name:"RESOURCES", link: "/"},
]


function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <div className='container md:flex flex-col md:flex-row fixed top-0 w-full px-12 py-4 items-center'>                    
      {/* MOBILE MENU */}
      <div className='md:hidden block mobile-menu top-5 right-0 absolute px-4' onClick={()=> setOpen(!open)}>
      {open ?<i className='fa fa-times text-xl'/> : <i className='fa fa-bars text-xl'/>}
      </div>
      <div className="logo"><img src={Logo} alt="" /></div>
      <div className={`md:flex flex-1 md:items-center md:pb-0 justify-between pb-8 text-center absolute md:static rounded md:z-auto z-[-1] w-full md:w-auto
         transition-all ease-in duration-500 ${open ? 'top-20 bg-darkVoilet text-white w-64' : 'top-[-400px] bg-white'}`}>
        <div className="menu">
          <ul className='flex flex-col md:flex-row pl-8'>
            {Links.map((link, key) => {
              return <li key={key} className='px-4 py-4'><a href={link.link}>{link.name}</a></li>
            })}
          </ul>
        </div>
        <hr className='w-44 mx-8 text-center my-4'/>
        <div className="btn flex flex-col md:flex-row">
          <button className='py-4'>Log In</button>
          <button className='rounded-full bg-cyan px-8 py-2 my-4 text-white mx-4'>Sign Up</button>
        </div>
      </div>
    </div>
  )
}

export default Navbar